import {css, tokens, media} from '@sail/ui';
import {helmTokens} from '@sail/helm';

export const styles = {
  popover: css({
    backgroundColor: 'surface',
    boxShadow: 'xlarge',
    border: 'none',
    maxWidth: '1080px',
    [media.up(tokens.viewport.medium)]: {
      position: 'relative',
      left: `calc(-1 * ${tokens.space.medium})`,
    },
  }),
  popoverUnprocessed: css({
    ':after': {
      content: '" "',
      width: 'space.0',
      height: 'space.0',
      position: 'absolute',
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      borderTop: `10px solid ${tokens.color.background.offset}`,
      bottom: '-10px',
      left: `${tokens.space[250]}`,
      transform: 'translateX(-50%)',
    },
  }),
  buttonTrigger: css({
    stack: 'x',
    gap: 'space.125',
    font: 'body.medium',
    border: 'none',
    paddingX: 'space.0',
    paddingY: 'xxsmall',
    backgroundColor: 'transparent',
    display: 'inline',
    textColor: 'action.secondary',
    textAlign: 'left',
    cursor: 'pointer',
    ':hover': {
      textColor: 'action.secondary.hovered',
    },
    transition: `all ${helmTokens.transition.hover}`,
  }),
  buttonTriggerUnprocessedCss: css({
    alignSelf: 'flex-start',
  }),
  countryList: css({
    margin: 'space.0',
    padding: 'medium',
    listStyleType: 'none',
    gap: 'small',
  }),
  countryListUnsupportedCss: css({
    columnCount: '1',
    columnGap: `${tokens.space.xlarge}`,
    columnFill: 'auto',
    [media.up(tokens.viewport.medium)]: {
      columnCount: '2',
      maxHeight: '1280px',
    },
    [media.up(tokens.viewport.xlarge)]: {
      columnCount: '4',
      maxHeight: '640px',
    },
  }),
  countryListItem: css({
    marginBottom: 'space.125',
    gapX: 'small',
    gapY: 'xxsmall',
  }),
  countryListItemUnsupportedCss: css({
    display: 'grid',
    gridTemplate: `
      "flag label" 24px
      ". languages" auto
      / 21px auto
    `,
    alignItems: 'center',
    breakInside: 'avoid',
  }),
  countryFlagIconUnsupportedCss: css({
    gridArea: 'flag',
  }),
  activeCountryCheckIcon: css({
    textColor: tokens.color.icon.emphasized,
  }),
  activeCountryCheckIconUnsupportedCss: css({
    gridArea: 'flag',
    justifySelf: 'center',
  }),
  countryLabel: css({
    font: 'body.medium',
    textColor: 'emphasized',
  }),
  countryLabelUnsupportedCss: css({
    gridArea: 'label',
    flexGrow: '0',
  }),
  activeCountryLabel: css({
    fontWeight: 'semibold',
  }),
  countryLanguageList: css({
    gapX: 'small',
    padding: 'space.0',
    listStyleType: 'none',
    lineHeight: '14px',
    gapY: 'xsmall',
  }),
  countryLanguageListUnsupportedCss: css({
    display: 'flex',
    gridArea: 'languages',
    justifySelf: 'start',
    flexWrap: 'wrap',
  }),
  countryLanguage: css({
    display: 'block',
    font: 'label.small',
    fontSize: '12px',
    textColor: 'subdued',
    whiteSpace: 'nowrap',
    marginY: 'space.0',
    lineHeight: '14px',
    transition: helmTokens.transition.hover,
    ':hover': {
      textColor: 'emphasized',
    },
  }),
  activeCountryLanguage: css({
    fontWeight: 'semibold',
    textColor: 'emphasized',
  }),
};
